export class GetOrderDetailsRequest {
  orderNo: string = null;
  scenarioId: string = null;

  constructor(orderNumber?,scenarioId?) {
    this.orderNo = orderNumber;
    this.scenarioId = scenarioId ;
  }

  toQueryString() {
    return `/${this.orderNo}?scenarioId=${this.scenarioId}`
  }
}